var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31134,
    stopColor: "#df2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#840000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.49487,60.9079c0-6.18256-5.01196-11.19452-11.19458-11.19452s-11.19452,5.01196-11.19452,11.19452,5.01196,11.19458,11.19452,11.19458,11.19458-5.01196,11.19458-11.19458ZM61.30029,67.75317c-3.78046,0-6.84521-3.06476-6.84521-6.84528s3.06476-6.84521,6.84521-6.84521,6.84528,3.06476,6.84528,6.84521-3.06476,6.84528-6.84528,6.84528Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.30029,
    cy: 60.9079,
    r: 3.70758
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.67993,48.17163l16.11841-9.30554c.78955-.45587.78955-1.59558,0-2.05145l-5.6098-3.23877-18.48682,10.67346,6.79388,3.9223c.36639.21155.81787.21155,1.18433,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.49585,27.50885l-16.11823,9.30585c-.78961.45587-.78961,1.59558,0,2.05145l5.13184,2.96277,18.48712-10.67334-6.31641-3.64673c-.36639-.21155-.81787-.21155-1.18433,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.50519,43.46454v18.68835c0,.41125.21936.7912.5755.99683l16.18451,9.34412c.76733.44305,1.7265-.11072,1.7265-.99683v-18.68817c0-.41119-.21936-.7912-.5755-.99677l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.7265.11072-1.7265.99677Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetProductsScraper);
export default __webpack_public_path__ + "static/media/target-products-scraper.7f92e681893b60dd765e058931155e8f.svg";
export { ForwardRef as ReactComponent };